import { daysUntil, fromNow } from '../../utils/dates';

export const EXPIRY_WARNING_DAYS = 7;

/**
 * level: ok | warning | error, with the expiry line shown under the account and, when not ok, the reason for the
 * reconnect prompt
 */
export function connectionHealth(connection) {
  if (!connection.is_valid) {
    return {
      level: 'error',
      expiry: 'Needs reconnect',
      prompt: connection.error_message || 'This connection stopped working. Reconnect to resume syncing.',
    };
  }
  if (!connection.expires_at) return { level: 'ok', expiry: 'Token does not expire' };
  const days = daysUntil(connection.expires_at);
  if (days < 0) {
    return { level: 'error', expiry: `Expired ${fromNow(connection.expires_at)}`,
      prompt: 'The access token has expired. Reconnect to resume syncing.' };
  }
  const expiry = `Expires ${fromNow(connection.expires_at)}`;
  if (days <= EXPIRY_WARNING_DAYS) {
    return { level: 'warning', expiry,
      prompt: `The access token expires ${fromNow(connection.expires_at)}. Reconnect to keep syncing.` };
  }
  return { level: 'ok', expiry };
}


// How many connections are not working (error) and expiring soon (warning)
export function healthCounts(connections) {
  const levels = connections.map((connection) => connectionHealth(connection).level);
  return {
    error: levels.filter((level) => level === 'error').length,
    warning: levels.filter((level) => level === 'warning').length,
  };
}
